import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ItemSelectorConfig, SelectedItem } from '../interface';
import { ItemSelectorServiceV2 } from '../item-selector-v2.service';

@Component({
  templateUrl: './item-selector-dialog.component.html',
  styleUrl: './item-selector-dialog.component.scss',
})
export class ItemSelectorDialogComponent {
  protected config: ItemSelectorConfig;
  protected selectedItems: SelectedItem[];

  constructor(
    public dialogRef: MatDialogRef<ItemSelectorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private itemSelectorService: ItemSelectorServiceV2,
  ) {
    this.config = data.config;
    this.selectedItems = data.selectedItems;
  }

  onSelect() {
    const selectedItems = this.itemSelectorService.selectedItems();
    this.dialogRef.close({ selectedItems: selectedItems });
  }
}
